export const isGiftContext = (path: string) => {
    return path?.indexOf('/create-gift') !== -1;
};

export const isInvitationContext = (path: string) => {
    return path?.indexOf('/create-invitation') !== -1;
};

export const isCoiContext = (path: string) => {
    return path?.indexOf('/create-coi') !== -1;
};

export const isTradeAssociationContext = (path: string) => {
    return path?.indexOf('/create-trade-association') !== -1;
};

export const isSponsoringContext = (path: string) => {
    return path?.indexOf('/create-sponsoring') !== -1;
};

export const isContractContext = (path: string) => {
    return path?.indexOf('/create-contract') !== -1;
};

export const isLegalSupportContext = (path: string) => {
    return path?.indexOf('/create-legal-support') !== -1;
};

export const isLobbyingtContext = (path: string) => {
    return path?.indexOf('/create-lobbying') !== -1;
};

export const isPoaContext = (path: string) => {
    return path?.indexOf('/create-poa') !== -1;
};

export const isGeneralContext = (path: string) => {
    return path?.indexOf('/create-general') !== -1;
};

export const isEApprovalContext = (path: string) => {
    return path?.indexOf('/create-eapproval') !== -1;
};

export const isInquiryContext = (path: string) => {
    return path?.indexOf('/create-inquiry') !== -1;
};

export const isDisputeContext = (path: string) => {
    return path?.indexOf('/create-dispute') !== -1;
};

export const isHomeCreateWizardContext = (path: string) =>
    isGiftContext(path)
    || isInvitationContext(path)
    || isSponsoringContext(path)
    || isCoiContext(path)
    || isContractContext(path)
    || isLegalSupportContext(path)
    || isEApprovalContext(path)
    || isLobbyingtContext(path)
    || isPoaContext(path)
    || isGeneralContext(path)
    || isInquiryContext(path)
    || isTradeAssociationContext(path)
    || isDisputeContext(path);

export const shouldShowPersonalHome = (pathname: string, personalContext: boolean) =>
    pathname === '/'
    || !personalContext
    || isHomeCreateWizardContext(pathname);